import { Box } from "@mui/material";
import React, { useState } from "react";
import { Lightbox } from "react-modal-image";

/**
 * Read-only photo thumbnails, tap to enlarge: an entry's reference photos
 * while the checklist is filled out, or a past answer's photos. Each photo's
 * `url` is the signed link the read returned; it expires, so it is only ever
 * used straight from that read.
 */
export default function ChecklistReferencePhotos({
  photos = [],
  alt = "Referenzfoto",
  size = 88
}) {
  const [lightboxImage, setLightboxImage] = useState("");
  const shown = photos.filter(photo => photo?.url);
  if (!shown.length) return null;

  return (
    <>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
        {shown.map(photo => (
          <Box
            key={photo.fileid}
            component="img"
            src={photo.url}
            alt={alt}
            onClick={() => setLightboxImage(photo.url)}
            sx={{
              borderRadius: "4px",
              cursor: "zoom-in",
              height: size,
              objectFit: "cover",
              width: size
            }}
          />
        ))}
      </Box>
      {lightboxImage ? (
        <Lightbox
          large={lightboxImage}
          alt={alt}
          hideZoom={false}
          onClose={() => setLightboxImage("")}
        />
      ) : null}
    </>
  );
}
